<div class="chat-window" *ngIf="channel; else noChannel">
  <!-- Channel header -->
  <div class="cw-header" *ngIf="showHeader">
    <div class="cw-header-info">
      <span class="cw-header-avatar" aria-hidden="true">{{ headerAvatarInitials }}</span>
      <div class="cw-header-text">
        <!-- Editable title for group/entity channels -->
        <ng-container *ngIf="isRenaming; else titleDisplay">
          <div class="cw-rename-wrap">
            <input
              class="cw-rename-input"
              [(ngModel)]="renameValue"
              (keyup.enter)="commitRename()"
              (keyup.escape)="cancelRename()"
              [disabled]="renaming"
            />
            <button
              class="cw-rename-confirm"
              (click)="commitRename()"
              [disabled]="renaming"
              title="Save"
            >
              <i class="pi pi-check"></i>
            </button>
            <button class="cw-rename-cancel" (click)="cancelRename()" title="Cancel">
              <i class="pi pi-times"></i>
            </button>
          </div>
        </ng-container>
        <ng-template #titleDisplay>
          <span
            class="cw-title"
            [class.cw-title--editable]="channel?.channel_type !== 'direct'"
            (click)="channel?.channel_type !== 'direct' && startRename()"
            [title]="channel?.channel_type !== 'direct' ? 'Click to rename' : ''"
            >{{ getChannelTitle() }}</span
          >
        </ng-template>
        <span class="cw-subtitle">{{ getChannelSubtitle() }}</span>
      </div>
    </div>
    <div class="cw-header-actions">
      <button
        *ngIf="channel?.channel_type !== 'direct'"
        class="cw-add-member-btn"
        (click)="openAddMemberDialog()"
        title="Add member"
      >
        <i class="pi pi-user-plus"></i>
        <span class="cw-add-member-label">Add Member</span>
      </button>
      <button
        *ngIf="entityInfo?.web_route"
        class="cw-link-btn"
        (click)="(null)"
        title="View linked record"
      >
        <i class="pi pi-external-link"></i>
      </button>
      <button
        *ngIf="channel?.channel_type !== 'direct'"
        class="cw-close-btn"
        (click)="confirmClose()"
        title="Close channel"
      >
        <i class="pi pi-trash"></i>
      </button>
    </div>
  </div>

  <div class="cw-member-strip" *ngIf="shouldShowInlineMembers">
    <button class="cw-member-link" type="button" (click)="openParticipantsDialog()">
      {{ participantCountLabel }}
    </button>
  </div>

  <!-- <app-chat-connection-banner></app-chat-connection-banner> -->

  <!-- Close channel confirm -->
  <p-dialog
    [(visible)]="showCloseConfirm"
    [modal]="true"
    [closable]="!closing"
    header="Close Channel"
    [style]="{ width: '380px' }"
  >
    <p class="close-confirm-msg">
      Archive <strong>{{ getChannelTitle() }}</strong
      >? Members will no longer be able to send messages.
    </p>
    <ng-template pTemplate="footer">
      <button class="cw-dialog-cancel" (click)="showCloseConfirm = false" [disabled]="closing">
        Cancel
      </button>
      <button class="cw-dialog-danger" (click)="doCloseChannel()" [disabled]="closing">
        <i *ngIf="closing" class="pi pi-spin pi-spinner"></i>
        <span *ngIf="!closing">Archive Channel</span>
      </button>
    </ng-template>
  </p-dialog>

  <!-- Message list -->
  <div class="cw-messages" #messageList>
    <div *ngIf="hasMore" class="cw-load-more">
      <button (click)="loadOlderMessages()" [disabled]="loading">
        <i class="pi pi-chevron-up"></i> Load older messages
      </button>
    </div>

    <div *ngIf="loading && messages.length === 0" class="cw-loading">
      <i class="pi pi-spin pi-spinner"></i>
    </div>

    <app-message-item
      *ngFor="let msg of messages; let i = index; trackBy: trackById"
      [message]="msg"
      [members]="members"
      [isGroupChat]="isGroupChannel"
      [showAvatar]="isGroupChannel && (i === 0 || messages[i - 1]?.sender_id !== msg?.sender_id)"
      [showSender]="isGroupChannel && (i === 0 || messages[i - 1]?.sender_id !== msg?.sender_id)"
      [compact]="i > 0 && messages[i - 1]?.sender_id === msg?.sender_id"
      (openThread)="onOpenThread(msg)"
      (react)="onReactToMessage({ message: msg, emoji: $event })"
      (retry)="onRetryMessage(msg)"
    >
    </app-message-item>
  </div>

  <div *ngIf="!isGroupChannel && typingUsers.size > 0" class="cw-typing cw-typing--direct"
    aria-label="The other person is typing">
    <span class="typing-dots" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
    </span>
  </div>

  <div *ngIf="isGroupChannel && typingMembers.length > 0" class="cw-group-typing">
    <div *ngFor="let typingUser of typingMembers" class="cw-group-typing-user">
      <div class="cw-typing-avatar">
        <img *ngIf="typingUser.member?.profile_pic_url || typingUser.member?.profile_pic"
          [src]="typingUser.member?.profile_pic_url || typingUser.member?.profile_pic" [alt]="typingUser.displayName" />

        <span *ngIf="!typingUser.member?.profile_pic_url && !typingUser.member?.profile_pic"
          class="cw-typing-avatar-initials">
          {{ getMemberInitials(typingUser.member?.user_name || typingUser.displayName) }}
        </span>
      </div>
      <span class="typing-dots" [attr.aria-label]="typingUser.displayName + ' is typing'"
        [title]="typingUser.displayName + ' is typing'">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </div>
  </div>

  <!-- Message input -->
  <app-message-input
    [channelId]="channel.id"
    [members]="members"
    (messageSent)="onMessageSent($event)"
    (typing)="onTyping($event)"
  >
  </app-message-input>
</div>

<ng-template #noChannel>
  <div class="cw-empty-state">
    <i class="pi pi-comments"></i>
    <h3>Select a channel</h3>
    <p>Choose a channel from the left to start chatting.</p>
  </div>
</ng-template>

<p-dialog
  [(visible)]="showParticipantsDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '420px' }"
  styleClass="participants-dialog"
  [header]="getChannelTitle()"
  appendTo="body"
>
  <div class="participants-dialog">
    <button class="participants-add-btn" type="button" (click)="openAddMemberFromParticipants()">
      <span class="participants-add-icon">
        <i class="pi pi-plus"></i>
      </span>
      <span>Add Members</span>
    </button>

    <div class="participants-section-title">{{ participantCountLabel }}</div>

    <div class="participants-list" *ngIf="members.length; else noMembers">
      <div class="participants-item" *ngFor="let member of members">
        <span class="participants-avatar">{{ getMemberInitials(member.user_name) }}</span>
        <div class="participants-info">
          <span class="participants-name">{{ member.user_name }}</span>
          <span class="participants-role">{{ member.role }}</span>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<ng-template #noMembers>
  <div class="participants-empty">No Members found.</div>
</ng-template>

<!-- Add Member Dialog -->
<p-dialog
  [(visible)]="showAddMemberDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '420px' }"
  header="Add Member"
  styleClass="participants-dialog"
  [closable]="true"
  appendTo="body"
>
  <div class="add-member-form">
    <div class="am-search-wrap">
      <i class="pi pi-search am-search-icon"></i>
      <input
        pInputText
        type="text"
        placeholder="Search by name or email"
        [(ngModel)]="addMemberQuery"
        (ngModelChange)="onAddMemberInput()"
        class="am-input"
      />
      <i *ngIf="addMemberSearching" class="pi pi-spin pi-spinner am-search-spin"></i>
    </div>

    <div class="am-results">
      <div *ngFor="let user of addMemberResults" class="am-result-item" (click)="addMember(user)">
        <i class="pi pi-user"></i>
        <div class="am-result-info">
          <span class="am-result-name">{{ user.user_name }}</span>
          <div class="dm-result-email-role">
            <span class="dm-result-email">
              {{ user.email }}
            </span>
            <span class="dm-result-role">
              {{ user.role_name }}
            </span>
          </div>
        </div>
        <i *ngIf="addMemberAdding" class="pi pi-spin pi-spinner"></i>
      </div>
      <div
        *ngIf="!addMemberSearching && addMemberQuery.length >= 2 && addMemberResults.length === 0"
        class="am-no-results"
      >
        No users found (or all already members)
      </div>
    </div>
  </div>
</p-dialog>
